import React, { useEffect,useState } from 'react'
import { loadBusinessDetails, saveBusinessDetails, isBusinessDetailsComplete, hydrateBusinessDetails } from './businessDetails';
import BusinessDetailsForm from './BusinessDetailsForm';
import MarketingTopNav from './MarketingTopNav';
import LocationCreditsCard from './LocationCreditsCard';
import TopHeader from '../template/TopHeader';
import { useDispatch, useSelector } from "react-redux";
import SettingInputControls from './SettingInputControls';
import SlidePanel from '../shared/SlidePanel';
import BrandCard from '../marketing-v2/features/brand/BrandCard';
import { EMAIL_TEMPLATES_V2_VISIBLE } from '../../config/featureFlags';
import { Modal, Pagination } from 'react-bootstrap';
import animationData from '../../assets/animation-data/loader.json'
import { marketingAction } from "../../_actions/marketing.actions";
import { marketingService } from "../../_services/marketing.service";
import { autoTopupPence } from '../marketing-v2/features/sms-composer/SmsWalletTopupModal';
import { formatPrice } from '../pricing/money';
import Lottie from 'react-lottie';
import {paymentService} from "../../_services";
// import toast from '../shared/Toast';
// import {loadStripe} from "@stripe/stripe-js";
// import siteSetting from "../../config/env";
// import { BackArrow } from '../SvgIcon';

// const stripePromise = loadStripe(siteSetting.stripeKey);

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
  };

/**
 * What salon-controlled marketing means for THIS self-employed stylist right
 * now, in plain words. `row` is their own controlledMarketing entry.
 */
function seControlCopy(row, salonName) {
    const salon = salonName || 'Your salon';
    const salonOn = Number(row && row.salonConsent) === 1;
    const youOn = Number(row && row.selfEmpConsent) === 1;
    if (salonOn && youOn) {
        return `${salon} runs your marketing. Your clients get the salon's campaigns, and you don't send your own or top up a balance while this is on. Switch off Your consent to run your own marketing again.`;
    }
    if (salonOn) {
        return `${salon} has offered to run your marketing. Switch on Your consent and the salon sends to your clients for you, and you stop sending your own. Leave it off to keep running your own.`;
    }
    if (youOn) {
        return `You've said yes, but ${salon} hasn't switched this on, so you still run your own marketing: your campaigns, to your own clients, from your own message balance.`;
    }
    return `You run your own marketing: your campaigns go to your own clients, from your own message balance. If ${salon} offers to run it for you, you can accept here.`;
}

function MarketingSetting(props) {
    const dispatch = useDispatch();
    const getSalonMarketingSetting = useSelector(state=>state?.getSalonMarketingSetting);

    const userInfo = useSelector(state=>state?.user?.userInfo);
    const [isLoader, setIsLoader] = useState(false);
    const [isSalonOwner,setIsSalonOwner] = useState(0);
    const [salonId,setSalonId] = useState('');
    const [salonData,setSalonData] = useState([]);
    const [teamPanelOpen,setTeamPanelOpen] = useState(false);
    // Business legal details for marketing email footers (Companies Act
    // disclosures for Ltd companies, trading name for the self-employed)
    const [bizDetails, setBizDetails] = useState({ legalForm: '', registeredName: '', companyNumber: '', placeOfRegistration: 'England and Wales', registeredOffice: '', tradingName: '' });
    const [bizSaved, setBizSaved] = useState(false);
    const [lastSavedBiz, setLastSavedBiz] = useState('');
    // View mode once details are saved; edit mode for first fill or changes
    const [bizEditing, setBizEditing] = useState(true);
    // Auto-recharge for marketing credits: the on/off switch lives here so
    // salons can stop automatic card charges without opening Buy credits.
    const [autoRecharge, setAutoRecharge] = useState(null); // null until loaded
    const [arSaving, setArSaving] = useState(false);
    const [arSaved, setArSaved] = useState(false);
    const [arError, setArError] = useState(null);
    // Whose wallet this caller has. A self-employed stylist whose marketing the
    // salon covers or runs has no wallet of their own to recharge, so the
    // auto-recharge card is not theirs to see. Default true: owners and older
    // backends are unaffected.
    const [canTopUpWallet, setCanTopUpWallet] = useState(true);
    const [managedBySalonName, setManagedBySalonName] = useState('');
    const [cardList,setCardList] = useState([]);
    const [cardPopup, setCardPopup] = useState(false);
    const [cardPrimaryToggle, setCardPrimaryToggle] = useState(false);
    const [selectedCard, setSelectedCard] = useState({});
    const [defaultPayment, setDefaultPayment] = useState();
    
    // const showCardPopup = (card)=>{
    //     setSelectedCard(card);
    //     if(defaultPayment===card?.id){
    //         setCardPrimaryToggle(true);
    //     }else{
    //         setCardPrimaryToggle(false);
    //     }
    //     // setCardPrimaryToggle(e?.target?.checked);
    //     setCardPopup(true)
    // }
    const HideCardPopup = ()=>{
        setCardPopup(false)
        setSelectedCard({});
    }

    useEffect(() => {
        const salonId = localStorage.getItem('salonId');
        setSalonId(salonId);
        const applyBiz = (storedBiz) => {
            if (!storedBiz) return;
            const merged = { legalForm: '', registeredName: '', companyNumber: '', placeOfRegistration: 'England and Wales', registeredOffice: '', tradingName: '', ...storedBiz };
            setBizDetails(merged);
            setLastSavedBiz(JSON.stringify(merged));
            if (isBusinessDetailsComplete(merged)) setBizEditing(false);
        };
        applyBiz(loadBusinessDetails(salonId));
        // Refresh the cache from the backend (survives new devices).
        hydrateBusinessDetails(salonId).then(applyBiz);
        setIsSalonOwner(userInfo?.hairdresser?.isSalonOwner);
        getMarketingSetting();
        checkpaymentMethodAdded();

        if(defaultPayment===selectedCard?.id){
            setCardPrimaryToggle(true);
        }
        
     /* eslint-disable-next-line */
    }, []);


    // Current auto-recharge state rides on the marketing settings payload
    useEffect(() => {
        let alive = true;
        dispatch(marketingAction.getSettings())
            .then((res) => {
                const r = res?.data?.responseData?.result;
                if (alive) setAutoRecharge((r && r.autoRecharge) || { enabled: false });
                if (alive && r && r.canTopUpWallet === false) setCanTopUpWallet(false);
                if (alive && r && r.managedBySalonName) setManagedBySalonName(r.managedBySalonName);
            })
            .catch(() => { if (alive) setAutoRecharge({ enabled: false }); });
        return () => { alive = false; };
    }, [dispatch]);

    const toggleAutoRecharge = () => {
        if (!autoRecharge || arSaving) return;
        const next = { ...autoRecharge, enabled: !autoRecharge.enabled };
        setAutoRecharge(next);
        setArSaving(true);
        setArSaved(false);
        setArError(null);
        marketingService.smsWalletAutoRecharge({
            enabled: next.enabled,
            // BE reads thresholdSms as a credit threshold
            thresholdSms: Number(next.thresholdCredits ?? next.thresholdSms) || 200,
            topupAmountGBP: Number(next.topupAmountGBP) || 25,
        })
            .then(() => { setArSaving(false); setArSaved(true); })
            .catch(() => {
                setArSaving(false);
                setArError('Could not save that. Please try again.');
                setAutoRecharge((a) => ({ ...a, enabled: !next.enabled }));
            });
    };

    useEffect(()=>{
        if(cardList?.length===1){
            if(defaultPayment!==cardList[0].id){
                    cardMakePrimary();
            }
        }
     /* eslint-disable-next-line */
    },[cardList])

 
      const updateMarketingSetting = (data) => {
        const params = {
            hairdresserId:data?.hairdresserId,
            salonConsent:data?.salonConsent,
            selfEmpConsent:data?.selfEmpConsent,
            controlledSettingId:data?.controlledSettingId
        }
   
        // Keep this screen's copy in step with the switch the stylist just
        // flipped (it describes who runs their marketing right now).
        setSalonData((prev) => prev.map((d) => (d.controlledSettingId === data?.controlledSettingId ? { ...d, ...data } : d)));
        dispatch(marketingAction.updateMarketingSetting(params)).then((res) => {

        });
      };

      // Toggle one stylist's consent in place (optimistic) and persist.
      const setEmpConsent = (emp, field, value) => {
        const updated = { ...emp, [field]: value ? 1 : 0 };
        setSalonData((prev) => prev.map((d) => (d.hairdresserId === emp.hairdresserId ? updated : d)));
        updateMarketingSetting(updated);
      };

      const getMarketingSetting = () => {
        dispatch(marketingAction.getMarketingSetting()).then((res) => {
          if (res.data.statusCode === 1) {
            if (res?.data?.responseData?.result.length>0) {
              let data = res?.data?.responseData?.result;
            //   dispatch(marketingAction.setSalonMarketingSetting(data));
               setSalonData(data);
            }
            setIsLoader(false);
          }else{
            setIsLoader(false);
          }
        });
      };

    const checkpaymentMethodAdded = () => {
        let params={};
        paymentService.checkCardAdded(params)
            .then(function(res){
                if(res.data.statusCode===1) {
                    let paymentMethodId = res.data.responseData?.stripeCustomer?.invoice_settings?.default_payment_method;
                    if(paymentMethodId!==undefined){
                        setDefaultPayment(paymentMethodId)
                    }
                    
                    if(res.data.responseData?.result?.data.length>0){
                        if(res.data.responseData?.result?.data.length===1){
                            setSelectedCard(res.data.responseData?.result?.data[0]);
                        }else{
                            setSelectedCard({});
                        }
                        setCardList(res.data.responseData?.result?.data)
                    }
                }
            })
    };

    // const cardRemove = () => {
    //     if(selectedCard && (selectedCard?.id!==undefined && selectedCard?.id!=='')){
    //     let params={
    //         stripePaymentMethodId:selectedCard?.id
    //     };
    //     paymentService.cardRemove(params)
    //         .then(function(res){
    //             if(res.data.statusCode===1) {
    //                 checkpaymentMethodAdded();
    //                 HideCardPopup();
    //             }
    //         })
    //     }
    // };

    const cardMakePrimary = () => {
        if(selectedCard && (selectedCard?.id!==undefined && selectedCard?.id!=='')) {
            console.log('card list', selectedCard);
            if (cardPrimaryToggle === true) {
                let params = {
                    stripePaymentMethodId: selectedCard?.id
                };
                paymentService.cardMakePrimery(params)
                    .then(function (res) {
                        if (res.data.statusCode === 1) {
                            console.log("res", res.data.responseData?.result);
                            checkpaymentMethodAdded();
                            HideCardPopup();
                        }
                    })
            }else{
                HideCardPopup();
            }
        }
    };

    // const paymentMethodAdd = async () => {
    //     let params={};
    //     const stripe = await stripePromise;
    //     paymentService.paymentMethodAdd(params)
    //         .then(function(res){
    //             if(res.data.statusCode===1) {
    //                 let sessionId=res.data.responseData?.result.id;
    //                 if(sessionId!=="") {
    //                     stripe.redirectToCheckout({
    //                         sessionId: sessionId,
    //                     }).then(function (res) {
    //                         console.log("stripe res=", res);

    //                     }).catch(function (error) {
    //                         toast.error(error.messages);
    //                         console.log("stripe error=", error);
    //                     })
    //                 }else{
    //                     toast.error("Payment gateway error");
    //                 }
    //             }else{
    //                 //return false;
    //             }
    //         })
    // };



    // function isCardExpired(card) {
    //     let expirationDate = `${card?.card?.exp_month}/${card?.card?.exp_year}`;
    //     var parts = expirationDate.split('/');
    //     var expirationMonth = parseInt(parts[0], 10);
    //     var expirationYear = parseInt(parts[1], 10);
    //     var currentDate = new Date();
    //     var currentMonth = currentDate.getMonth() + 1; // January is 0
    //     // Check if the card has expired
    //     if (expirationYear < currentDate.getFullYear() || (expirationYear === currentDate.getFullYear() && expirationMonth < currentMonth)) {
    //         return true; 
    //     } else {
    //         return false; 
    //     }
    // }
    

  const setBizField = (field, value) => {
      setBizSaved(false);
      setBizDetails(prev => ({ ...prev, [field]: value }));
  };
  const bizComplete = isBusinessDetailsComplete(bizDetails);
  const bizDirty = JSON.stringify(bizDetails) !== lastSavedBiz;
  const handleSaveBizDetails = () => {
      if (!bizComplete) return;
      saveBusinessDetails(salonId, bizDetails);
      setLastSavedBiz(JSON.stringify(bizDetails));
      setBizSaved(true);
      setBizEditing(false);
  };
  const handleCancelBizEdit = () => {
      if (lastSavedBiz) setBizDetails(JSON.parse(lastSavedBiz));
      setBizEditing(false);
  };
  return(
    <div className="h_n catalogue-no-header">
    <div className="body_container cm_bg_white">
        <TopHeader title="" {...props} />
        <div className='catalogue-page-wrapper'>
            <MarketingTopNav activeTab="settings" />
            <div className='catalogue-content-container'>
                <div className='container'>
                <div className='row'>
                    {isLoader?<div className='col-12'>
                    <div className='salon-body-main-wrp booking-urlpage'>
                        <div className='new-stng-cmn'>
                        <div className="text-center pr-md-5">
                            <Lottie options={defaultOptions}
                                    height={50}
                                    width={200}
                            />
                            <h4 className="text-center">Loading Data...</h4>
                        </div>
                        </div>
                    </div>
                </div>:
                <div className='col-12'>
                    <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                   <div style={{ marginBottom: '22px' }}>
                        <h1 className="mk-page-title" style={{ fontSize: '24px', fontWeight: 700, letterSpacing: '-0.3px', color: '#1A1A1E', margin: '0 0 6px' }}>Config</h1>
                        <p style={{ fontSize: '14px', color: '#8E8E93', margin: 0 }}>{EMAIL_TEMPLATES_V2_VISIBLE ? 'Your brand, sender details and who manages marketing for your team.' : 'Your sender details and who manages marketing for your team.'}</p>
                   </div>

                   {EMAIL_TEMPLATES_V2_VISIBLE && <BrandCard />}

                   <div style={{ background: '#fff', border: '1px solid #ECECF0', borderRadius: '14px', padding: '24px', marginBottom: '16px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', flexWrap: 'wrap', marginBottom: '6px' }}>
                            <h5 style={{ margin: 0, fontSize: '17px', fontWeight: 700, color: '#1A1A1E' }}>Business details</h5>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {isBusinessDetailsComplete(bizDetails) ? (
                                    <span style={{ fontSize: '11.5px', fontWeight: 700, color: '#007EA0', background: 'rgba(0,126,160,0.1)', borderRadius: '100px', padding: '4px 11px' }}>Complete</span>
                                ) : (
                                    <span style={{ fontSize: '11.5px', fontWeight: 700, color: '#A05A1F', background: 'rgba(160,90,31,0.1)', borderRadius: '100px', padding: '4px 11px' }}>Needed before sending</span>
                                )}
                                {!bizEditing ? (
                                    <button onClick={() => { setBizSaved(false); setBizEditing(true); }} style={{ padding: '7px 16px', border: '1px solid #ECECF0', borderRadius: '100px', background: '#fff', fontSize: '12.5px', fontWeight: 600, color: '#1A1A1E', cursor: 'pointer', fontFamily: 'inherit' }}>Edit</button>
                                ) : null}
                            </div>
                        </div>
                        <p style={{ fontSize: '13.5px', color: '#8E8E93', lineHeight: 1.55, margin: '0 0 20px', maxWidth: '640px' }}>These appear in the footer of your marketing emails to identify the sender, as UK law requires. Limited companies must show their registration details; if you are a sole trader, your name and salon address are enough.</p>
                        <div style={{ maxWidth: '560px' }}>
                            {!bizEditing ? (
                                <div>
                                    {[
                                        { label: 'Business type', value: bizDetails.legalForm === 'ltd' ? 'Limited company' : 'Self-employed / sole trader' },
                                        ...(bizDetails.legalForm === 'ltd' ? [
                                            { label: 'Registered name', value: bizDetails.registeredName },
                                            { label: 'Company number', value: bizDetails.companyNumber },
                                            { label: 'Place of registration', value: bizDetails.placeOfRegistration },
                                            { label: 'Registered office', value: bizDetails.registeredOffice },
                                        ] : bizDetails.tradingName ? [
                                            { label: 'Trading name', value: bizDetails.tradingName },
                                        ] : []),
                                    ].map(row => (
                                        <div key={row.label} style={{ display: 'flex', justifyContent: 'space-between', gap: '16px', padding: '11px 0', borderBottom: '1px solid #F2F2F7' }}>
                                            <span style={{ fontSize: '13px', color: '#8E8E93', flexShrink: 0 }}>{row.label}</span>
                                            <span style={{ fontSize: '13.5px', fontWeight: 600, color: '#1A1A1E', textAlign: 'right' }}>{row.value || '-'}</span>
                                        </div>
                                    ))}
                                    {bizSaved ? (
                                        <p style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '13px', fontWeight: 600, color: '#007EA0', margin: '14px 0 0' }}>
                                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                                            Saved
                                        </p>
                                    ) : null}
                                </div>
                            ) : (
                            <BusinessDetailsForm value={bizDetails} onChange={setBizField} prefillAddress={userInfo?.hairdresser?.salon?.formattedAddress} />
                            )}
                            {bizEditing && bizDetails.legalForm ? (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '12px', marginTop: '18px' }}>
                                    {!bizComplete && bizDirty ? (
                                        <span style={{ fontSize: '12.5px', fontWeight: 600, color: '#A05A1F' }}>Fill in the remaining details to save</span>
                                    ) : null}
                                    {lastSavedBiz && isBusinessDetailsComplete(JSON.parse(lastSavedBiz)) ? (
                                        <button onClick={handleCancelBizEdit} style={{ padding: '11px 20px', border: '1px solid #ECECF0', borderRadius: '10px', background: '#fff', fontSize: '14px', fontWeight: 600, color: '#1A1A1E', cursor: 'pointer', fontFamily: 'inherit' }}>Cancel</button>
                                    ) : null}
                                    <button
                                        onClick={handleSaveBizDetails}
                                        disabled={!bizComplete || !bizDirty}
                                        style={{
                                            padding: '11px 26px',
                                            backgroundColor: (!bizComplete || !bizDirty) ? '#E5E5EA' : '#29282D',
                                            color: (!bizComplete || !bizDirty) ? '#8E8E93' : '#fff',
                                            border: 'none', borderRadius: '10px', fontSize: '14px', fontWeight: 600,
                                            cursor: (!bizComplete || !bizDirty) ? 'default' : 'pointer', fontFamily: 'inherit'
                                        }}
                                    >
                                        Save
                                    </button>
                                </div>
                            ) : null}
                        </div>
                   </div>

                   <div style={{ background: '#fff', border: '1px solid #ECECF0', borderRadius: '14px', padding: '18px 24px', marginBottom: '16px' }}>
                        <div className='_marketing_setting' style={{ padding: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '14px' }}>
                            <div style={{ minWidth: 0 }}>
                                <h5 style={{ margin: '0 0 4px', fontSize: '15px', fontWeight: 700, color: '#1A1A1E', display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                                    Salon controlled marketing
                                    {isSalonOwner === 1 && salonData?.length > 0 ? (
                                        <span style={{ fontSize: '11px', fontWeight: 700, color: '#4B4B52', background: '#F2F2F7', borderRadius: '100px', padding: '3px 10px' }}>
                                            {salonData.filter(d => d.salonConsent === 1 && d.selfEmpConsent === 1).length} of {salonData.length} opted in
                                        </span>
                                    ) : null}
                                </h5>
                                <p style={{ fontSize: '12.5px', color: '#8E8E93', lineHeight: 1.55, margin: 0, maxWidth: '640px' }}>
                                    {isSalonOwner === 1
                                        ? "If you and a self-employed stylist both switch this on, you run their marketing. Their own clients are included in your campaigns and automations, even private ones you cannot see in your client list, and they stop sending their own or topping up a balance. Their free allowance joins yours. You offer first, then they accept from their own account. If either of you switches it off, their clients leave your marketing straight away."
                                        : seControlCopy(salonData?.[0], managedBySalonName || userInfo?.hairdresser?.salon?.salonName)}
                                </p>
                            </div>
                            {isSalonOwner === 1 && salonData?.length > 0 ? (
                                <button type="button" onClick={() => setTeamPanelOpen(true)} style={{ padding: '9px 16px', border: '1px solid #ECECF0', borderRadius: '10px', background: '#fff', fontSize: '13px', fontWeight: 600, color: '#1A1A1E', cursor: 'pointer', fontFamily: 'inherit', flexShrink: 0 }}>
                                    Manage stylists
                                </button>
                            ) : null}
                        </div>

                        {/* Self-employed view keeps its own inline consent control. */}
                        {isSalonOwner !== 1 && salonData?.length > 0 ? (
                            <div style={{ marginTop: '16px' }}>
                                {salonData.map((emp,i)=>(<SettingInputControls updateMarketingSetting={updateMarketingSetting} indexNum={i} key={'self_emp_'+i} data={emp} loginType={isSalonOwner} />))}
                            </div>
                        ) : null}
                        {salonData?.length === 0 ? (
                            <p style={{ fontSize: '13px', color: '#8E8E93', margin: '14px 0 0' }}>No self-employed staff at this salon yet, so there is nothing to manage here.</p>
                        ) : null}
                        </div>
                   </div>

                   {canTopUpWallet ? (
                   <div style={{ background: '#fff', border: '1px solid #ECECF0', borderRadius: '14px', padding: '18px 24px', marginBottom: '16px' }}>
                        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '14px' }}>
                            <div style={{ minWidth: 0 }}>
                                <h5 style={{ margin: '0 0 4px', fontSize: '15px', fontWeight: 700, color: '#1A1A1E' }}>Auto top-up</h5>
                                <p style={{ fontSize: '12.5px', color: '#8E8E93', lineHeight: 1.55, margin: 0, maxWidth: '640px' }}>
                                    {autoRecharge === null
                                        ? 'Checking your current setting…'
                                        : autoRecharge.enabled
                                            ? (() => {
                                                const a = autoTopupPence(autoRecharge);
                                                return `When your message balance drops below ${formatPrice(a.thresholdPence)}, ${formatPrice(a.amountPence)} is added on your saved card. Change the amounts from Top up on the campaigns page.`;
                                            })()
                                            : 'Off: your message balance never tops up by itself. Turn this on (or fine-tune the amounts) from Top up on the campaigns page too.'}
                                </p>
                                {arSaving ? (
                                    <p style={{ fontSize: '12px', fontWeight: 600, color: '#8E8E93', margin: '8px 0 0' }}>Saving…</p>
                                ) : arError ? (
                                    <p style={{ fontSize: '12px', fontWeight: 600, color: '#B14438', margin: '8px 0 0' }}>{arError}</p>
                                ) : arSaved ? (
                                    <p style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', fontWeight: 600, color: '#007EA0', margin: '8px 0 0' }}>
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                                        Saved
                                    </p>
                                ) : null}
                            </div>
                            {autoRecharge !== null ? (
                                <button
                                    type="button"
                                    role="switch"
                                    aria-checked={!!autoRecharge.enabled}
                                    aria-label="Auto top-up"
                                    onClick={toggleAutoRecharge}
                                    disabled={arSaving}
                                    style={{ width: 44, height: 26, borderRadius: 100, border: 'none', cursor: arSaving ? 'default' : 'pointer', padding: 2, flexShrink: 0, background: autoRecharge.enabled ? '#007EA0' : '#DEDEE2', transition: 'background 0.15s', opacity: arSaving ? 0.6 : 1 }}
                                >
                                    <span style={{ display: 'block', width: 22, height: 22, borderRadius: '50%', background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.25)', transition: 'transform 0.15s', transform: autoRecharge.enabled ? 'translateX(18px)' : 'translateX(0)' }} />
                                </button>
                            ) : null}
                        </div>
                   </div>
                   ) : null}

                   {isSalonOwner === 1 ? <LocationCreditsCard /> : null}

                   {teamPanelOpen ? (
                       <SlidePanel title="Salon controlled marketing" width={420} onClose={() => setTeamPanelOpen(false)}>
                           <div className="sp-form">
                               <p className="sp-hint" style={{ marginTop: 0 }}>
                                   Offer to run marketing for a stylist. It only starts once they accept from their own account. Until then they run their own, to their own clients. Once they accept, their own clients are included in your campaigns and automations.
                               </p>
                               {salonData.map((emp) => {
                                   const joined = emp.selfEmpConsent === 1;
                                   return (
                                       <div key={emp.hairdresserId || emp.controlledSettingId} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 0', borderBottom: '1px solid #F2F2F7' }}>
                                           <span style={{ flex: 1, fontSize: '14px', fontWeight: 600, color: '#1A1A1E', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{emp.selfEmpName || 'Stylist'}</span>
                                           <span style={{ fontSize: '11px', fontWeight: 700, color: joined ? '#007EA0' : '#8E8E93', background: joined ? 'rgba(0,126,160,0.1)' : '#F2F2F7', borderRadius: '100px', padding: '3px 9px', flexShrink: 0 }}>
                                               {joined ? 'Opted in' : 'Not opted in'}
                                           </span>
                                           <button
                                               type="button"
                                               role="switch"
                                               aria-checked={emp.salonConsent === 1}
                                               aria-label={`Salon consent for ${emp.selfEmpName || 'stylist'}`}
                                               onClick={() => setEmpConsent(emp, 'salonConsent', emp.salonConsent !== 1)}
                                               style={{ width: 44, height: 26, borderRadius: 100, border: 'none', cursor: 'pointer', padding: 2, flexShrink: 0, background: emp.salonConsent === 1 ? '#007EA0' : '#DEDEE2', transition: 'background 0.15s' }}
                                           >
                                               <span style={{ display: 'block', width: 22, height: 22, borderRadius: '50%', background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.25)', transition: 'transform 0.15s', transform: emp.salonConsent === 1 ? 'translateX(18px)' : 'translateX(0)' }} />
                                           </button>
                                       </div>
                                   );
                               })}
                           </div>
                       </SlidePanel>
                   ) : null}
                   </div>

                   {/* <div className='salon-body-main-wrp account--password-temp new-stng-cmn __marketing '>
                     <div className='_marketing_setting _card_parent'>
                        <h5>Billing Card</h5>
                        <p className='mb-4'>This is the card that will be used for billing once your SMS allocation has been used..</p>
                        <div className='table-responsive payout_table '>
                        <table className={`table table-borderless `}>
                        <tbody>
                            {cardList.map((item)=>{
                            return(
                                <tr key={item?.id} className='_card_row'  onClick={()=>showCardPopup(item)}>
                                <td>{item?.card?.brand}</td>
                                <td>••••{item?.card?.last4}</td>
                                <td>{item?.card?.exp_month} / {item?.card?.exp_year}</td>
                                <td className='_btn_group'>
                                {isCardExpired(item)?<span className='btn btn-sm'>Expired</span>:null}
                                {defaultPayment===item?.id?<span className='btn btn-sm'>Default</span>:null}
                                </td>
                                <td className='_icon'><BackArrow/></td>
                            </tr>
                             )
                           })
                          }
                        </tbody>
                       </table>
                       </div>
                       <div className='text-right mt-4'>
                       <button className="btn btn-inf ml-auto pl-5 pr-5" onClick={()=>paymentMethodAdd()}>Add New Card</button>
                       </div>
                     </div>
                        </div> */}
                </div>}
                    
                </div>
            </div>
        </div>
                
    </div>

   {/*<Modal 
    show={cardPopup} 
    // onHide={HideCardPopup}
    centered
    className="bg_white_modal text-center card_popup_modal "
    
     blurClass="blure_bg" 
     size="lg"
    //  className='payout_modal'
     >
        <i className="fa fa-times cm_hide_mod" onClick={HideCardPopup} />
        <Modal.Body>
           <div className='card_popup text-left'>
               <div className='_card_info'>
                    <h4>{selectedCard?.card?.brand}
                        {isCardExpired(selectedCard)?<span className='ml-3'>Expired</span>:null}
                    </h4>
                    <p>{selectedCard?.card?.last4}</p>
               </div>
               <div className="_expired mt-4">
                    <p >Expiry date</p>
                    <h6>{selectedCard?.card?.exp_month} / {selectedCard?.card?.exp_year}</h6>
               </div>
 
               {cardList?.length===1?null:<div className="salon_switch_container pl-0 mt-5">
               <h6 className='mr-5'>Make default card for payments</h6>
               <label className="switch">
                 <input 
                    type="checkbox"
                    checked={cardPrimaryToggle}
                    onChange={(e)=>setCardPrimaryToggle(e?.target?.checked)}
                    disabled={cardPrimaryToggle}
                    /><span className="slider round"></span>
                </label>
               </div>}
              
               <div className='btn__group mt-5'>
                {cardList?.length>1?<button className="btn btn-disc pl-5 pr-5" onClick={(e)=>cardRemove()} >Delete</button>:null}
                {cardList?.length===1?null:<button className="btn btn-inf pl-5 pr-5" onClick={()=>cardMakePrimary()}>Save</button>}
               </div>
           </div>
        </Modal.Body>
                    </Modal> */}
</div>
</div>
)

}



export default MarketingSetting;
const cardrow=[0,0,0,0,0,0]